import axios from './axios'

export function getTrailerList() {
  return axios({
    method: "get",
    url: '/api/v1/vehicle?type=Trailer'
  })
}

export function createTrailer(sub) {
  return axios({
    method: "post",
    url: '/api/v1/vehicle/',
    data: sub
  })
}

export function updateTrailer(id,sub) {
  return axios({
    method: "put",
    url: '/api/v1/vehicle/' + id + '/',
    data: sub
  })
}

export function deleteTrailer(id) {
  return axios({
    method: "delete",
    url: '/api/v1/vehicle/' + id + '/'
  })
}

export function getTrailerByID(id) {
  return axios({
    method: "get",
    url: '/api/v1/vehicle/' + id + '/'
  })
}